import "./App.css";
import "./styles/blog.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import StarterKit from "./pages/StarterKit";
import AdminLogin from "./pages/AdminLogin";
import AdminBlogList from "./pages/AdminBlogList";
import AdminBlogEditor from "./pages/AdminBlogEditor";
import { Navigate } from "react-router-dom";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#EBEBEB",
          color: "#6b6b6b",
        }}
      >
        Loading...
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/starter-kit" element={<StarterKit />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/blogs"
                element={
                  <RequireAuth>
                    <AdminBlogList />
                  </RequireAuth>
                }
              />
              <Route
                path="/admin/blogs/new"
                element={
                  <RequireAuth>
                    <AdminBlogEditor />
                  </RequireAuth>
                }
              />
              <Route
                path="/admin/blogs/:id"
                element={
                  <RequireAuth>
                    <AdminBlogEditor />
                  </RequireAuth>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
